import { z } from 'zod/v4';

export const tidJwtSchema = z.object({
  token_type: z.literal('bearer'),
  expires_in: z.number(),
  refresh_token: z.string().min(1),
  id_token: z.string().min(1),
  access_token: z.string().min(1),
});

export type TidJwt = z.infer<typeof tidJwtSchema>;
